var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassicInternational3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "yafc7bwsya",
    width: "158.6%",
    height: "158.6%",
    x: "-29.3%",
    y: "-29.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "vtj0qjpgqb",
    cx: 25.6,
    cy: 25.6,
    r: 25.6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-536 -227) translate(546 237)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#yafc7bwsya)",
    xlinkHref: "#vtj0qjpgqb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#vtj0qjpgqb"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#0071CE",
    strokeLinecap: "square",
    d: "M12.449 16.033c1.667-.644 3.333-.966 5-.966 1.667 0 3.333.322 5 .966h0",
    transform: "rotate(-15 17.449 15.55)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0071CE",
    strokeLinecap: "square",
    d: "M29.449 16.033c1.667-.644 3.333-.966 5-.966 1.667 0 3.333.322 5 .966h0",
    transform: "scale(-1 1) rotate(-15 0 277.215)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14 31H32V37H14z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 23.5,
    r: 2.5,
    fill: "#0071CE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 23.5,
    r: 2.5,
    fill: "#0071CE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    x: 7,
    y: 7,
    stroke: "#0071CE",
    strokeWidth: 2,
    rx: 19
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    x: 18,
    y: 34,
    fill: "#0071CE",
    rx: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassicInternational3);
export default __webpack_public_path__ + "static/media/classicInternational3.ab25afd15934a93c373e0b266cb6fb76.svg";
export { ForwardRef as ReactComponent };